import { useState } from 'react';
import clsx from 'clsx';
import { sanitizeHtml } from '../../lib/inbox/email-html';

/**
 * Toggle voor geciteerde tekst (replies, signatures) in een email.
 * Default ingeklapt — klikken expanded de gesanitized HTML.
 *
 * Geëxtraheerd uit InboxThreadPage.tsx in batch D sub-stap 9a.
 */
export function CollapsibleQuote({ html }: { html: string }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="mt-2">
      <button
        onClick={() => setExpanded(!expanded)}
        className="text-xs text-slate-400 hover:text-slate-600 flex items-center gap-1 py-1"
      >
        <svg className={clsx('w-3 h-3 transition-transform', expanded && 'rotate-90')} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
        {expanded ? 'Verberg geciteerd bericht' : 'Toon geciteerd bericht'}
      </button>
      {expanded && (
        <div
          className="mt-1 pl-3 border-l-2 border-slate-200 text-slate-400 prose prose-sm max-w-none prose-p:my-1 prose-headings:my-2"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
        />
      )}
    </div>
  );
}
